import { useDispatch, useSelector } from "react-redux";
import { clearLogoutData } from "../../redux/logout/action";

const useSession = () => {
  const dispatch = useDispatch();
  const invalidSessionModal = useSelector((state) => state.Logout.logoutFlag);

  const handleSessionExpired = () => {
    if (!invalidSessionModal) {
      dispatch(clearLogoutData(true));
    }
  };

  return handleSessionExpired;
};

export default useSession;
